import React from 'react';
import ReactDOM from 'react-dom';

import {forEachMatchingElement, uimanager} from 'ui-manager';
import {store} from "../stores";
import {Provider} from "react-redux";
import {UserAvatarContainer} from "../components/user/Avatar";
import {theme} from "../ui/theme";
import {MuiThemeProvider} from "@material-ui/core/styles";

uimanager.add(el =>
  forEachMatchingElement(el, "[data-user-avatar]", node => {
    const data = JSON.parse(node.dataset.userAvatar);

    ReactDOM.render(
      <Provider store={store}>
        <MuiThemeProvider theme={theme}>
          <UserAvatarContainer {...data}/>
        </MuiThemeProvider>
      </Provider>,
      node
    );
  })
);
